import React from 'react'
import { generateRandomId } from 'src/utils/domHelper'
import * as Styles from './iconCardGrid.module.scss'

export type IconCardGridCard = {
  iconUrl?: string
  iconAlt?: string
  title?: string
  description?: string
}

export type IconCardGridContent = {
  anchor?: string
  headline?: string
  cards: IconCardGridCard[]
}

type Props = {
  content: IconCardGridContent
}

const IconCardGrid = ({ content }: Props) => {
  const { anchor = generateRandomId(), headline, cards } = content

  if (!cards || cards.length === 0) {
    return null
  }

  return (
    <section id={anchor} className={Styles.iconCardGrid}>
      <div className={Styles.inner}>
        {headline && <h2 className={Styles.headline}>{headline}</h2>}
        <div className={Styles.grid}>
          {cards.map(card => (
            <div
              key={`icon-card-${card.title ?? ''}-${card.iconUrl ?? ''}-${
                card.description ?? ''
              }`}
              className={Styles.card}
            >
              <div className={Styles.cardHeader}>
                {card.iconUrl && (
                  <img
                    src={card.iconUrl}
                    alt={card.iconAlt ?? ''}
                    className={Styles.icon}
                  />
                )}
                {card.title && (
                  <h3 className={Styles.cardTitle}>{card.title}</h3>
                )}
              </div>
              {card.description && (
                <p className={Styles.cardDescription}>{card.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default IconCardGrid
